import styled from '@emotion/styled';

import { Card, CardHeader, CardContent, useTheme, lighten, darken } from '@mui/material';

import { BasicFlex, LabelUpper } from '../../../utils/Common';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import ClearAllRoundedIcon from '@mui/icons-material/ClearAllRounded';

import { startCase } from 'lodash';

const { formatGenericDate, formatCurrency } = require('../../../utils/util');

const SHCard = styled(BasicFlex)`
  border-radius: 12px;
  border: 1px solid ${props => props.$color ? lighten(props.$color, 0.8) : props.theme.colors.border};
  border-left: 3px solid ${props => props.$color || props.theme.colors.border};
  background-color: ${props => props.$color ? lighten(props.$color, 0.95) : props.theme.colors.lightBg};
  overflow: hidden;
  padding: 1rem;
  align-items: flex-start;
  gap: 1.2rem;
  font-weight: 500;
`

const Chip = styled.div`
  color: ${props => darken(props.$color, 0.5)};
  background-color: ${props => lighten(props?.$color, 0.75)};
  padding: .1rem 1rem;
  border-radius: 3px;
  text-transform: uppercase;
  letter-spacing: .6px;
  font-size: 1.3rem;
`

const SHTicket = styled.div`
  color: ${props => props.theme.colors.lightText};
  font-size: 1.2rem;
`

const SHStatus = styled.div`
  font-weight: 500;
`

const HeaderBar = styled(BasicFlex)`

`

const SHMain = styled(BasicFlex)`
  align-items: flex-start;
`;

const SHInfo = styled(BasicFlex)`
  flex-direction: column;
  gap: .3rem;
  flex-grow: 1;
`

const SHActions = styled(BasicFlex)`
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  width: auto;
`

const SHTitle = styled.div`
  font-size: 1.5rem;
  color: ${props => darken(props?.$color, 0.6)};
  font-weight: 500;
`

const SHSpecialist = styled.div`
  color: ${props => darken(props?.$color, .5)};
  font-weight: 400;
`

const StageChip = styled(BasicFlex)`
  width: fit-content;
  padding: .2rem .5rem;
  background-color: white;
  border: 1px solid ${props => props.theme.colors.border};
  font-size: 1.2rem;
  border-radius: 3px;
`

const Labels = styled(BasicFlex)`
  margin-top: 1rem;
  justify-content: flex-start;
  gap: 3rem;
  align-items: flex-start;
`;

const Label = styled(BasicFlex)`
  flex-direction: column;
  width: auto;
  gap: .3rem;
`

const Price = styled.div`
  font-size: 1.6rem;
  color: ${props => darken(props?.$color, 0.6)};
`

const ApptDetails = styled.div`
  color: ${props => darken(props.theme.colors.mildText, .2)};
  margin-top: .4rem;
`

const ServiceHistoryCard = ({ sh = {}, color }) => {
  const theme = useTheme();
  let st = sh.source_type;
  let palette = sh.source_type === "repair" ? "secondary" : "primary";
  return (
    <SHCard $color={color} dir="column">
      <BasicFlex>
      <HeaderBar justify="flex-start" gap="1rem">
        {/* <SimpleChip label={sh.source_type} palette={palette} uc size="small" /> */}
        <Chip $color={color}>{startCase(st)}</Chip>
        <SHTicket>#{sh.ticket_num}</SHTicket>
        <SHStatus>{startCase(sh.status)}</SHStatus>
        {st === "repair" ? <StageChip gap=".5rem"><ClearAllRoundedIcon fontSize="small" color="basic" /> Step {sh.repair_order} / {sh.number_of_repairs}</StageChip> : null}
      </HeaderBar>
        <SHActions>
          <Price $color={color}>{formatCurrency(sh.price)}</Price>
        </SHActions>
      </BasicFlex>
      <SHMain>
        <SHInfo align="flex-start">
          <SHTitle $color={color}>{sh.name}</SHTitle>
          {st === "repair" ? (<SHSpecialist $color={color}>Specialist: {sh.specialist_name || sh.vendor_name}</SHSpecialist>) : null}
          {st === "repair" ? <Labels>
            <Label align="flex-start">
              <LabelUpper $size="1.3rem" $normal>Accepted</LabelUpper>
              <div>{formatGenericDate(sh.created_at, "short")}</div>
            </Label>
            {sh.status !== "scheduled" ? <Label align="flex-start">
              <LabelUpper $size="1.3rem" $normal>Started</LabelUpper>
              <div>{formatGenericDate(sh.started_at, "short")}</div>
            </Label> : null}
            <Label align="flex-start">
              <LabelUpper $size="1.3rem" $normal>Due</LabelUpper>
              <div>{formatGenericDate(sh.scheduled_for, "short")}</div>
            </Label>
            {sh.status === "completed" ? <Label align="flex-start">
              <LabelUpper $size="1.3rem" $normal>Completed</LabelUpper>
              <div>{formatGenericDate(sh.completed_at, "short")}</div>
            </Label> : null}
          </Labels> : null}

          {st === "service" ? <ApptDetails>{formatGenericDate(sh.started_at)} &middot; {sh.stylist_name}</ApptDetails> : null}
        </SHInfo>

        
      </SHMain>
    </SHCard>
  )
};

export default ServiceHistoryCard